module.exports = __webpack_public_path__ + "img/type_cover_04.d3e09717.png";